import React from "react";
import "./styles.css";

export const Button = ({
  text,
  onClick,
  inactive,
  footer,
  icon,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  className,
  children
}) => {
  const btnClass = `standard-button ${className} ${
    inactive ? "inactive-button" : ""
  } ${footer ? "footer-btn" : ""}`;
  const data = () => {
    switch (icon?.position) {
      case "left":
        return (
          <button
            className={btnClass}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseLeave}
          >
            {children}
            {text}
          </button>
        );
      case "right":
        return (
          <button
            className={btnClass}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseLeave}
          >
            {text}
            {children}
          </button>
        );
    }
  };

  return icon ? (
    data()
  ) : (
    <button
      className={btnClass}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      {text}
    </button>
  );
};
